import { Button, Stack, Typography } from '@mui/material';
import NotFound from '../../assets/images/404.svg';
import { Link } from 'react-router';
import LogoutOutlined from '@mui/icons-material/LogoutOutlined';

export default function Page404() {
    return (
        <Stack sx={{ alignItems: 'center' }}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    height: '30vh',
                    maxWidth: '80%',
                    margin: '5%',
                }}
            >
                <img
                    src={NotFound}
                    style={{
                        maxWidth: '100%',
                        maxHeight: '100%',
                        objectFit: 'contain',
                    }}
                />
            </div>

            <Stack direction="column" justifyContent={'center'} alignItems="center" spacing={4}>
                <Typography variant="h3">Page not found</Typography>
                <Typography>We can't find the page that you are looking for... !</Typography>

                <Button
                    variant="contained"
                    color="info"
                    component={Link}
                    to="/"
                    endIcon={<LogoutOutlined />}
                >
                    Return to Home
                </Button>
            </Stack>
        </Stack>
    );
}
